<template>
  <v-container>
    <module-bar :title="title" />

    <v-card outlined>
      <v-card-text>
        <v-form v-model="valid" ref="formItem">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field label="Apodo" v-model="name" :rules="rulesName" />
            </v-col>
            <v-col cols="12" md="6">
              <v-select :items="items" item-text="name" item-value="id" label="Tipo" v-model="type" :rules="rulesType"
                :loading="loadingTypeItems" />
            </v-col>
            <v-col cols="12">
              <v-textarea outlined label="Descripcion" v-model="description" />
            </v-col>

            <v-col cols="12" md="12" v-if="schema == 'edit'">
              <v-switch v-model="enabled" :label="labelStatus" @change="changeStatus" />
            </v-col>

            <v-col cols="12" md="12" v-if="!enabled">
              <v-textarea :rules="rulesDetails" label="Describa porque se deshabilito el inconveniente" outlined
                v-model="details" />
            </v-col>


            <v-col cols="12" md="4">
              <v-file-input label="Foto #1" v-model="photo1" show-size accept="image/png, image/jpeg, image/bmp"
                :rules="rulesPhoto" />
            </v-col>
            <v-col cols="12" md="4">
              <v-file-input label="Foto #2" v-model="photo2" show-size accept="image/png, image/jpeg, image/bmp"
                :rules="rulesPhoto" />
            </v-col>
            <v-col cols="12" md="4">
              <v-file-input label="Foto #3" v-model="photo3" show-size accept="image/png, image/jpeg, image/bmp"
                :rules="rulesPhoto" />
            </v-col>

            <v-col cols="12" md="4" v-if="item">
              <v-img style="cursor: pointer" v-if="item.photo_1" width="200" :src="item.photo_1"
                :lazy-src="item.photo_1_thumb" aspect-ratio="1" contain class="grey lighten-2"
                @click="openDialogPhoto(item.photo_1, 1)">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>

            <v-col cols="12" md="4" v-if="item">
              <v-img style="cursor: pointer" v-if="item.photo_2" width="200" :src="item.photo_2"
                :lazy-src="item.photo_2_thumb" aspect-ratio="1" contain class="grey lighten-2"
                @click="openDialogPhoto(item.photo_2, 2)">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>

            <v-col cols="12" md="4" v-if="item">
              <v-img style="cursor: pointer" v-if="item.photo_3" width="200" :src="item.photo_3"
                :lazy-src="item.photo_3_thumb" aspect-ratio="1" contain class="grey lighten-2"
                @click="openDialogPhoto(item.photo_3, 3)">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="schema=='edit'" :loading="loadingDeleteItem" text color="red" @click="deleteItem">eliminar inconveniente</v-btn>
        <v-spacer />
        <v-btn text color="red" v-if="schema == 'edit'" @click="closeDialogItem(null)">cancelar</v-btn>
        <v-btn :loading="loadingProcess" @click="processItem" text color="primary">{{ schema == "new" ? "GUARDAR" :
          "EDITAR"
        }}</v-btn>
      </v-card-actions>
    </v-card>

    <!-- dialogo foto -->
    <v-dialog v-if="item" v-model="dialogPhoto" width="800">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-img :src="photoSelected" />
        </v-card-text>

        <v-card-actions>
          <v-btn text color="red" @click="deletePhoto" :loading="loadingDeletePhoto">eliminar foto</v-btn>
          <v-spacer />
          <v-btn text @click="closeDialogPhoto">cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ModuleBar from "../General/ModuleBar.vue";
export default {
  components: { ModuleBar },
  props: ["schema", "title", "item", "click"],

  mounted() {
    this.loadTypeItems();
    if (this.item) {
      this.loadItem();
    }
  },

  data() {
    return {
      loadingDeleteItem: false,
      enabled: true,
      details: "",
      labelStatus: "INCONVENIENTE HABILITADO",
      dialogPhoto: false,
      loadingDeletePhoto: false,
      loadingTypeItems: false,
      items: [],
      valid: false,
      loadingProcess: false,
      name: "",
      type: 0,
      description: "",
      photo1: null,
      photo2: null,
      photo3: null,
      photoSelected: "",
      photoNumber: 0,

      rulesType: [(value) => (value && value > 0) || "Seleccione el tipo"],
      rulesName: [
        (value) => (value && value.length > 0) || "Ingrese el apodo",
      ], rulesDetails: [
        (value) => (value && value.length > 0) || "Ingrese el motivo de deshabilitacion",
      ],

      rulesPhoto: [
        (value) =>
          !value ||
          value.size < 4000000 ||
          "La foto no puede pesar mas de  4 Mb!",
      ],
    };
  },

  watch: {
    click() {
      this.loadTypeItems();
      this.loadItem();
    },
  },

  methods: {
    loadTypeItems() {
      this.loadingTypeItems = true;
      setTimeout(() => {
        this.$store.dispatch("findTypeItemsAction").then((res) => {
          this.items = res;
          this.loadingTypeItems = false;
        });
      }, 500);
    },

    processItem() {
      if (this.valid) {
        this.loadingProcess = true;
        setTimeout(() => {
          let payload = new FormData();

          payload.append("name", this.name);
          payload.append("type_id", this.type);
          payload.append("description", this.description);
          payload.append("enabled", this.enabled ? 1 : 0);
          payload.append("details", this.details);
          payload.append("photo1", this.photo1);
          payload.append("photo2", this.photo2);
          payload.append("photo3", this.photo3);

          if (this.schema == "edit") payload.append("item_id", this.item.id);

          let path =
            this.schema == "new" ? "storeItemAction" : "updateItemAction";

          this.$store
            .dispatch(path, payload)
            .then((res) => {
              this.loadingProcess = false;
              if (this.schema == "edit") this.closeDialogItem(res);
              this.clear();
            })
            .catch(() => {
              this.loadingProcess = false;
            });
        }, 500);
      } else {
        this.$refs.formItem.validate();
      }
    },

    clear() {
      this.name = "";
      this.type = 0;
      this.description = "";
      this.photo1 = null;
      this.photo2 = null;
      this.photo3 = null;
      this.$refs.formItem.resetValidation();
    },

    closeDialogItem(data) {
      this.$emit("closeDialogItem", data);
    },

    loadItem() {
      if (this.item) {
        this.name = this.item.name;
        this.type = parseInt(this.item.type_id);
        this.description = this.item.description;
        this.enabled = parseInt(this.item.enabled);
        this.details = this.item.details;
      }
    },

    openDialogPhoto(photo, number) {
      this.dialogPhoto = true;
      this.photoSelected = photo;
      this.photoNumber = number;
    },

    closeDialogPhoto() {
      this.dialogPhoto = false;
      this.photoSelected = "";
    },

    deletePhoto() {
      this.$confirm({
        message: `Quieres eliminar esta foto?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            this.loadingDeletePhoto = true;
            setTimeout(() => {
              let payload = {
                photo_number: this.photoNumber,
                item_id: this.item.id,
              };

              this.$store
                .dispatch("deletePhotoItemAction", payload)
                .then(() => {
                  this.loadingDeletePhoto = false;
                  this.dialogPhoto = false;
                  this.photoFinish();
                })
                .catch(() => {
                  this.loadingDeletePhoto = false;
                });
            }, 500);
          }
        },
      });
    },

    photoFinish() {
      if (this.photoNumber == 1) {
        this.item.photo_1 = null;
        this.item.photo_1_short = null;
        this.item.photo_1_thumb = null;
        this.item.photo_1_thumb_short = null;
      }
      if (this.photoNumber == 2) {
        this.item.photo_2 = null;
        this.item.photo_2_short = null;
        this.item.photo_2_thumb = null;
        this.item.photo_2_thumb_short = null;
      }
      if (this.photoNumber == 3) {
        this.item.photo_3 = null;
        this.item.photo_3_short = null;
        this.item.photo_3_thumb = null;
        this.item.photo_3_thumb_short = null;
      }
    },

    changeStatus() {
      this.labelStatus = this.enabled ? "MISION HABILITADA" : "MISION DESHABILITADA";

    },

    deleteItem() {
      this.$confirm({
        message: `Quieres eliminar este inconveniente?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch("deleteItemAction", { id: this.item.id })
              .then(() => {
                this.$emit("deleteItem", { id: this.item.id });
              })
          }
        },
      }); 
    }
  },
};
</script>

<style></style>
